<template>
    <div class="checklist-maker-preview" v-if="checklistItemsExists">
        <!-- NB: using v-for with range -->
        <tool-output-page v-for="index in itemCollections.length"
                          :page-number="index"
                          :page-count="itemCollections.length">
            <div class="checklist-maker-preview-header" v-if="index == 1">
                <h3 class="text-center">{{ docData.cardTitle }}</h3>

                <p>
                    Directions: Review each of the checklist items below and rate accordingly.
                </p>
            </div>
            <table class="preview-table">
                <tr>
                    <th>Item</th>
                    <th>Rating</th>
                </tr>
                <tr v-for="(item, i) in docData.checklistItems" :key="i">
                    <td class="item">
                        {{ item.text }}
                    </td>
                    <td class="rating-group">
                        <div v-for="response in item.responses" class="rating">
                            {{ response.value }}
                        </div>
                    </td>
                </tr>
            </table>
        </tool-output-page>

    </div>

</template>

<script>

import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'
import ChecklistMakerMixin from '@/providers/ChecklistMakerMixin'

export default Vue.extend({
    name: "ChecklistMakerPreview",
    mixins: [ToolMixin, ChecklistMakerMixin],
    data() {
        return {
            formsVisible: true,
        }
    },
    computed: {
        linesPerPage() {
            if (this.landscape) {
                return 12
            }
            if (this.docData.fontSize == "small") {
                return 37
            } else {
                return 30
            }
        },
        checklistItemsExists() {
            return this.docData.checklistItems && this.docData.checklistItems.length > 0
        },
        itemCollections() {
            let itemCollections = []
            itemCollections.push(this.docData.checklistItems)
            return itemCollections
        }
    },
    methods: {
        deleteForm(id) {
            this.deleteGoogleForm(id)
        }
    }
})

</script>

<style lang="scss">
.checklist-maker-preview {
    .tool-output-page--font-size-large {
        .table-internal, .preview-table {
            th, td, tr {
                font-size: 15px;
            }
        }
    }

    .preview-table {
        tr {
            margin-bottom: 15px;
        }

        th {
            padding-bottom: 10px;
        }

        .item {
            padding-right: 50px;
            padding-bottom: 20px;
            width: 60%;
        }

        .rating-group {
            display: flex;
            flex-direction: row;
            justify-content: start;
            margin-right: 15px;
        }

        .rating {
            padding-right: 40px;
        }
    }
}

</style>
